import gql from "graphql-tag";

const queryGetAllDocumentType = gql`
  query($limit: Int, $page: Int, $query: String) {
    getAllDocumentType(paging: { limit: $limit, page: $page }, query: $query) {
      id
      code
      title
      updatedAt
      createdAt
      author {
        id
        fullname
        username
      }
    }
  }
`;

const queryGetDocumentType = gql`
  query($id: ID!) {
    getDocumentType(id: $id) {
      id
      code
      title
      updatedAt
      createdAt
      author {
        id
        fullname
        username
      }
    }
  }
`;

export default { queryGetAllDocumentType, queryGetDocumentType };
